import { createClient } from '@church/api-client'

/**
 * Web talks to the API with httpOnly session cookies, so there is no token
 * store here. Requests are same-origin: the Vite dev server proxies `/api`
 * and `/health` to the API, exactly like the production reverse proxy — so
 * SameSite cookies behave identically in both. `VITE_API_URL` exists for the
 * rare split-origin deployment and stays empty otherwise.
 */
export const apiBaseUrl: string = import.meta.env.VITE_API_URL || window.location.origin

export const api = createClient(apiBaseUrl, {
  credentials: 'include',
  onUnauthorized: () => {
    // The session is gone. Hard-navigate rather than routing in place: every
    // query cache entry belongs to the dead session.
    if (!window.location.pathname.startsWith('/sign-')) {
      window.location.assign(`/sign-in?redirect=${encodeURIComponent(window.location.pathname)}`)
    }
  },
})
